import styled from 'styled-components';
export const Text = styled.div`
font-weight: ${props => props.fontweight};
font-size: ${props => props.fontsize};
text-align: center;
align-self: ${props => props.alignself};
`